<template>
  <div>
    <!-- Global Page Loader -->
    <transition name="fade">
      <div v-if="loading" class="global-loader">
        <div class="pulse-loader"></div>
      </div>
    </transition>

    <!-- Navbar -->
    <NavBar v-if="!$route.meta.hideNavBar" />

    <!-- Pages -->
    <router-view />
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "App",
  components: {
    NavBar,
  },

  setup() {
    const loading = ref(false);
    const router = useRouter();

    router.beforeEach((to, from, next) => {
      loading.value = true;
      next();
    });

    router.afterEach(() => {
      setTimeout(() => {
        loading.value = false;
      }, 350); // حركة ناعمة
    });

    return { loading };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  font-size: medium;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.toast-content {
  font-weight: 900;
}
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.pulse-loader {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: #325b90;
  animation: pulse 0.9s ease-in-out infinite;
  box-shadow: 0 0 0 #0e3f80;
}

@keyframes pulse {
  0% {
    transform: scale(0.75);
    box-shadow: 0 0 0 0 #325b90;
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 30px rgba(173, 17, 0, 0);
  }
  100% {
    transform: scale(0.75);
    box-shadow: 0 0 0 0 rgba(173, 17, 0, 0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
